module.exports = __webpack_public_path__ + "static/media/hearthBGDesktop.22a5ada4.webp";